import { differenceInYears, isBefore } from "date-fns"
import { z } from "zod"
import { stringRequired, textAreaDefaultMaxLength } from "@/models/common"
import { Certificate } from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeCreateLegalGuardianAttestationMutation.graphql"
import { Language } from "@/types/__generated__/union-types"

const isAtLeast18 = (birthdate: Date) => {
  const age = differenceInYears(new Date(), birthdate)
  return age >= 18
}

export const ChLegalGuardianAttestationSchema = z
  .object({
    language: z.custom<Exclude<Language, "ENGLISH">>(),
    durationFrom: z.date({ error: "common.fieldErrorList.requiredField" }),
    durationTo: z.date({ message: "common.fieldErrorList.invalidDateRange" }),
    certificate: z.custom<Certificate>(),
    firstName: stringRequired.max(200, { message: "common.fieldErrorList.characterLimit" }),
    lastName: stringRequired.max(200, { message: "common.fieldErrorList.characterLimit" }),
    birthDate: z
      .date({ error: "common.fieldErrorList.requiredField" })
      .refine(isAtLeast18, "patient.legalGuardianAttestation.minAge"),
    employer: stringRequired.max(200, { message: "common.fieldErrorList.characterLimit" }),
    additionalInformation: z
      .string()
      .max(textAreaDefaultMaxLength, { message: "common.fieldErrorList.characterLimit" }),
  })
  .superRefine((data, ctx) => {
    if (!data.durationTo || (data?.durationTo && isBefore(data.durationTo, data.durationFrom))) {
      ctx.addIssue({
        code: "custom",
        path: ["durationTo"],
        message: "common.fieldErrorList.invalidDateRange",
      })
    }
  })

export type ChLegalGuardianAttestationSchemaType = z.infer<typeof ChLegalGuardianAttestationSchema>
